import { Flex } from "@chakra-ui/react";
import React from "react";
import ReactPaginate from "react-paginate";
import "./Pagination.css";

const Pagination = (props) => {
    return (
        <Flex justifyContent="center">
            <ReactPaginate
                pageCount={
                    props.pageCount === undefined ? (props.selectedPage ? props.selectedPage + 1 : 2) : props.pageCount
                }
                pageRangeDisplayed={5}
                marginPagesDisplayed={3}
                breakLabel={""}
                previousLabel={"⟨"}
                nextLabel={"⟩"}
                forcePage={props.selectedPage === undefined ? 1 : props.selectedPage}
                onPageChange={props.changePage}
                containerClassName={"pagination-ul"}
                activeClassName={"currentPage"}
                previousClassName={"pageLabel-btn"}
                nextClassName={"pageLabel-btn"}
            />
        </Flex>
    );
};

export default Pagination;
